import { LocalStorageKeys } from "../types/enums";
import { betBuilderHandlers } from "./betBuilderReducer";
import { configHandlers } from "./configReducer";
import { oddsChangesHandlers } from "./oddsChangesReducer";
import { selectionHandlers } from "./selectionsReducer";
import { stakesHandlers } from "./stakesReducer";
import { computeBsVersion } from "../shared/utils/bs-version";

const handlers = {
  ...selectionHandlers,
  ...betBuilderHandlers,
  ...configHandlers,
  ...oddsChangesHandlers,
  ...stakesHandlers,
};

export const betSlipReducer = (
  state: IWidgetState,
  action: BetSlipActions,
): IWidgetState => {
  const handler = handlers[action.type];
  if (!handler) return state;

  const nextState = (
    handler as (s: IWidgetState, a: BetSlipActions) => IWidgetState
  )(state, action);

  const version = computeBsVersion(nextState.betSlipState);
  const newState: IWidgetState = {
    ...nextState,
    betSlipState: { ...nextState.betSlipState, version },
  };

  try {
    localStorage.setItem(
      LocalStorageKeys.BET_SLIP_WIDGET,
      JSON.stringify(newState),
    );
  } catch (error) {
    console.error("Error saving to localStorage:", error);
  }

  return newState;
};
